function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function deepMerge(baseTheme, overrideTheme) {
    const merged = {};
    Object.keys(baseTheme).forEach((key) => {
        if (key in overrideTheme) {
            if (isObject(baseTheme[key]) && isObject(overrideTheme[key])) {
                merged[key] = deepMerge(baseTheme[key], overrideTheme[key]);
            }
            else {
                merged[key] = overrideTheme[key];
            }
        }
        else {
            merged[key] = baseTheme[key];
        }
    });
    Object.keys(overrideTheme).forEach((key) => {
        if (!(key in baseTheme)) {
            merged[key] = overrideTheme[key];
        }
    });
    return merged;
}
export default deepMerge;
